import React, { useCallback, useMemo } from 'react'
import { taricDuty } from '../../../commonApis'
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType'
import { ValueBuildUpContext } from './ValueBuildUpContext'
const ValuBuildUpProvider = ({
  children,
  saveFunc,
  updateFunc,
  invoiceData,
  destinationCountry = "ES",
  customValueKey = 'customValue',
  statValueKey = 'statValue',
  createDutyFunc,
  deleteDutyFunc
}) => {
  const { isImportShipment, serviceType, countryCode } = useCurrentShipmentType()
  const isSpain = window.shipmentCountry === 'ES';
 const addDuties = useCallback(
   (taricData, merchandiseId, invoiceId, itemDuties, customValue) => {
     const { dutyMeasures, totalDutyAndTaxes } = taricData
     const deleteDutyStatus = () => {}
     const updateAddDutyStatus = () => {}
     if (itemDuties) {
       let obsoleteDuties = itemDuties.filter((duties) => duties.taxType.startsWith('A'))
       obsoleteDuties.forEach((duty) =>
         deleteDutyFunc(merchandiseId, duty.merchandiseDutyId, invoiceId, deleteDutyStatus)
       )
     }
     dutyMeasures?.map((duty) => {
       const payload = {
         taxRate: duty.dutyExpression?.slice(0, -1)?.replace(',', '.'),
         taxAmount: Number(duty.dutyAmount?.amount).toFixed(2),
         taxBase: customValue,
         taxType: duty.taxType,
       }
       console.log(payload)
       duty && createDutyFunc(merchandiseId, invoiceId, updateAddDutyStatus, payload)
       totalDutyAndTaxes &&
         (updateFunc(invoiceId, merchandiseId, {
           [statValueKey]: (Number(totalDutyAndTaxes?.amount) + Number(customValue))?.toFixed(2),
         }),
         saveFunc(merchandiseId, statValueKey, invoiceId))
     })
   },
   [saveFunc, updateFunc, invoiceData, createDutyFunc, deleteDutyFunc]
 )

 const actions = useMemo(
   () => ({
     updateItemTab: (payload) => {
       payload.forEach((invoice) => {
         invoice.merchandise.forEach((merchandise) => {
           const { merchandiseId, invoiceId, sumOfCustValue, sumOfStatValue, partyDependency } = merchandise
           if (isImportShipment) {
             let { convertedUnitValue, commodityCode, countryOfOrigin, unitCount, itemDuties } =
               invoiceData
                 .find((inv) => inv.invoiceId === invoiceId)
                 ?.merchandiseList?.find((merch) => merch.merchandiseId === merchandiseId)
            //  let customValue = (Number(sumOfCustValue) + Number(convertedUnitValue)).toFixed(2)
             let customValue = sumOfCustValue;
             updateFunc(invoiceId, merchandiseId, { [customValueKey]: customValue, partyDependency })
             saveFunc(merchandiseId, customValueKey, invoiceId,)
             !isSpain && taricDuty({
               shipmentType: serviceType,
               destinationCountry,
               countryOfOrigin,
               commodityCode,
               customValue,
               unitCount,
             }).then((res) => {
               let response = res?.data?.eventMessage
               console.log({ response,countryCode });
               
               (response?.code !== 500 ||
                 response?.code !== 400 ||
                 response?.rest?.code !== 500 ||
                 response?.rest?.code !== 400) &&
                 addDuties(response, merchandiseId, invoiceId, itemDuties, customValue)
             })
           } else {
             updateFunc(invoiceId, merchandiseId, {
               [statValueKey]: sumOfStatValue,
               [customValueKey]: sumOfStatValue,
             })
             saveFunc(merchandiseId, [statValueKey, customValueKey], invoiceId,{[statValueKey]: sumOfStatValue})
           }
         })
       })
     },
   }),
   [updateFunc, saveFunc]
 )

  return <ValueBuildUpContext.Provider value={actions}>{children}</ValueBuildUpContext.Provider>
}

export default ValuBuildUpProvider
